function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "166.27 223.38 166.27 166.27 223.38 166.27 223.38 135.56 135.56 135.56 135.56 223.38 166.27 223.38"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "288.62 166.27 345.73 166.27 345.73 223.38 376.44 223.38 376.44 135.56 288.62 135.56 288.62 166.27"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "345.73 288.62 345.73 345.73 288.62 345.73 288.62 376.44 376.44 376.44 376.44 288.62 345.73 288.62"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "223.38 345.73 166.27 345.73 166.27 288.62 135.56 288.62 135.56 376.44 223.38 376.44 223.38 345.73"
});

function SvgFullscreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.1a56381c.svg";
export { ForwardRef as ReactComponent };